import loadableWithRetry from '../common/loadableWithRetry'

const Share = loadableWithRetry(() => import('./Share'))

export default Share;
